import styled from '@emotion/styled'
import { css } from '@emotion/react'
import Typography from '../Typography'
import { ColorDeterminer, WidthContainer } from '../../utils/helpers.styles'

export const Footer = styled.footer`
  z-index: 2;
  position: relative;
`

export const TopSection = styled.div(
  WidthContainer,
  ColorDeterminer,
  ({
    theme,
    logoBackgroundColor,
    logoTextColor,
    logoTopBorder,
    logoBottomBorder,
  }) => {
    const colors = theme?.colors
    const background = colors?.[logoBackgroundColor]?.base?.hex
    const textColor = colors?.[logoTextColor]?.base?.hex
    const topBorder = logoTopBorder
      ? `1px solid ${colors?.[logoTopBorder]?.base?.hex}`
      : 'none'
    const bottomBorder = logoBottomBorder
      ? `1px solid ${colors?.[logoBottomBorder]?.base?.hex}`
      : 'none'

    return css`
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      min-height: 80px;
      background-color: ${background};
      color: ${textColor};
      border-bottom: ${bottomBorder};
      border-top: ${topBorder};
      padding-top: ${theme.spacing.sm};
      padding-bottom: ${theme.spacing.sm};

      .gatsby-image-wrapper {
        margin-bottom: 0 !important;
      }
      .sylex-image {
        min-height: 25px;
      }
    `
  }
)

export const BottomSection = styled.div(
  WidthContainer,
  ColorDeterminer,
  ({ theme, navigationBackgroundColor, navigationTextColor }) => {
    const colors = theme?.colors
    const background = colors?.[navigationBackgroundColor]?.base?.hex
    const textColor = colors?.[navigationTextColor]?.base?.hex

    return css`
      grid-row-gap: ${theme.spacing.md};
      grid-column-gap: ${theme.spacing.md};
      padding-top: ${theme.spacing.lg};
      padding-bottom: ${theme.spacing.lg};
      background-color: ${background};
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      justify-content: space-between;

      *,
      a,
      a:visited,
      a:link,
      .link {
        color: ${textColor};
      }

      @media (max-width: ${theme.breakpoints.md}) {
        grid-column-gap: 0px;
      }
    `
  }
)

export const LegalSection = styled.div(
  WidthContainer,
  ({ theme, disclaimerBackgroundColor, disclaimerTextColor }) => {
    const colors = theme?.colors
    const background = colors?.[disclaimerBackgroundColor]?.base?.hex
    const textColor = colors?.[disclaimerTextColor]?.base?.hex

    return css`
      padding-top: ${theme.spacing.lg} !important;
      padding-bottom: ${theme.spacing.lg} !important;
      background-color: ${background};
      color: ${textColor};
    `
  }
)

export const Nav = styled.nav`
  flex: auto;
  width: 50%;

  a {
    display: block;
    padding-bottom: 1em;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 0;
    flex: 1;
    width: auto;
  }
`

export const GroupLabel = styled(Typography)`
  margin-top: 0;
  font-weight: ${({ theme }) => theme.fonts.subheadings.md.weight};
`
